<template>
  <div>
    <el-dialog title="结算详情" :visible.sync="visible" width="800px" :before-close="handleClose" append-to-body>
      <el-table border :data="companyOption" style="width: 100%" max-height="500">
        <el-table-column prop="company_name" label="用工单位" min-width="120">
        </el-table-column>
        <el-table-column prop="total_amount" label="充值总额" min-width="100">
          <template slot-scope="scope">￥{{ scope.row.total_amount }}</template>
        </el-table-column>
        <el-table-column prop="send_amount" label="已发放总额" min-width="100">
          <template slot-scope="scope">￥{{ scope.row.send_amount }}</template>
        </el-table-column>
        <el-table-column prop="surplus_amount" label="可用余额" min-width="100">
          <template slot-scope="scope">￥{{ scope.row.surplus_amount }}</template>
        </el-table-column>
        <el-table-column prop="update_time" label="更新时间" width="160">
        </el-table-column>
      </el-table>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      companyOption:[]
    };
  },
  methods: {
    reset(done) {
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    getDetail() {
      this.$http
        .get("/admin/flex_salary/company", { params: {} }).then(res => {
          if (res.code == 1) {
            this.companyOption = res.data.list;
          }
        })
    },
  },
};
</script>
<style scoped>
.err-list {
  margin-top: 10px;
}

.sampleFile {
  position: absolute;
  left: 180px;
  top: 0px;
}

.sampleFile:hover {
  border-bottom: solid 1px #0376e7;
}
</style>